<template>
  <div>
    <el-form
      ref="ruleForm"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
    >
      <div style="display:flex">
        <el-form-item
          label="广告主账户id"
          prop="account_id"
        >
          <div style="display:flex">

            <el-button
              type="success"
              size="mini"
              @click="selectID"
            >选择</el-button>
            <el-tag v-if="ruleForm.account_id">{{ ruleForm.account_id }}-{{ account_name }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item
          label="品牌形象名称"
          prop="name"
          autocomplete="new-password"
        >
          <el-input v-model.trim="ruleForm.name" />
        </el-form-item>
      </div>
      <div>
        <!-- <el-form-item
          v-if="typer == 1"
          label="分销商密码"
        >
          <el-input
            v-model="ruleForm.agents_password"
            style="width: 300px;"
            show-password
            autocomplete="new-password"
          />
        </el-form-item>
        <el-form-item
          label="赠送比例(%)"
          prop="gift_ratio"
          style="margin-top: 30px;"
        >
          <el-input
            v-model="ruleForm.gift_ratio"
            style="width: 300px;"
          />
        </el-form-item>
        <el-form-item
          label="vip充值金额比(%)"
          prop="vip_day_ratio"
          style="margin-top: 30px;"
        >
          <el-input
            v-model="ruleForm.vip_day_ratio"
            style="width: 300px;"
          />
        </el-form-item> -->
        <el-form-item
          label="选择图片"
          prop="path"
          style="margin-top: 20px;"
        >
          <el-button
            type="success"
            size="mini"
            @click="merchantchat"
          >选择图片</el-button>

          <img
            v-if="ruleForm.path"
            :src="ruleForm.path"
            class="pic_img"
          >

        </el-form-item>
      </div>

      <el-form-item style="margin-top: 50px;margin-left: 400px;">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="图片库"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
    <el-dialog
      title="选择广告主账户id"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleId"
      width="50%"
      append-to-body
    >
      <accoutIdDialog
        ref="id"
        @close="close"
      />
    </el-dialog>

  </div>
</template>
<script>
import chooseimg from '@/views/sourceMaterial/components/imgComp.vue'
// import { alldatalist } from '@/api/providerAccountManagement/servicePorviderList.js'
import accoutIdDialog from './accoutIdDialog.vue'

export default {
  components: {
    chooseimg,
    accoutIdDialog
  },
  data() {
    return {
      ruleForm: {
        account_id: '',
        path: '',
        name: '',
        md5: ''
      },
      wechatname: '',
      rules: {
        account_id: [{ required: true, message: '请输入', trigger: 'blur' }],
        path: [{ required: true, message: '请选择图片', trigger: 'blur' }],
        name: [{ required: true, message: '请输入品牌名称', trigger: 'blur' }]
      },
      loading: false,
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      check: undefined,
      wechatVisible: false,
      dialogVisibler: false,
      dialogMerchant: false,
      arrs: [],
      merchant_ids: [],
      typer: null,
      idr: null,
      dialogVisibletwo: false,
      account_name: '',
      dialogVisibleId: false
    }
  },
  // 页面初始化挂载dom
  mounted() {
    console.log('111')
    // this.$nextTick(() => {
    //   //  执行echarts方法
    //   this.getLoadEcharts()
    // })
    // this.getLoadEcharts()
  },
  methods: {
    selectID() {
      this.dialogVisibleId = true
      this.$nextTick(() => {
        this.$refs.id.send()
      })
    },
    close(item) {
      this.ruleForm.account_id = item.account_id
      this.account_name = item.account_name
      this.dialogVisibleId = false
    },
    clickicon(img, key, name, item) {
      console.log('img, key:', img, key, name)
      this.dialogVisibletwo = false

      this.ruleForm.path = img
      this.ruleForm.md5 = item.md5
    },
    bandarrMerchant(arr, sp_strategy_no, arrname) {
      console.log('66666', arr)
      this.dialogMerchant = false
      this.merchant_ids = arr
      this.ruleForm.merchant_ids = []
      arr.forEach(element => {
        this.ruleForm.merchant_ids.push(element.merchant_id)
        console.log('this.ruleForm.merchant_ids:', this.ruleForm.merchant_ids)
      })
    },
    merchantchat() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // eslint-disable-next-line eqeqeq

          // this.ruleForm.md5 = md5(this.ruleForm.path)
          console.log(' this.ruleForm.agents_password :', this.ruleForm)
          this.$emit('submit', this.ruleForm, () => {
            this.ruleForm = {
              account_id: '',
              path: '',
              name: '',
              md5: ''
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    wechatclick() {
      this.wechatVisible = true
      this.$nextTick(() => {
        this.$refs.wechatview.send()
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    async changewr(val, item) {
      console.log(val, item)
      // await setReceiveMiniprogram({
      //   receive_miniprogram: val,
      //   id: item.id
      // })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    async send(row) {
      console.log('---', row)
      // const item = JSON.parse(JSON.stringify(row))
      // this.ruleForm.account_id = item.account_id
      // this.getlist(id, type)
    },
    rightclick(index) {
      this.arrs.splice(index, 1)
    },
    rightclick2(index) {
      this.merchant_ids.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 22px;
  margin: 10px;
}
.pic_img {
  width: 95px;
}
</style>
